<div class="details-tab">
  <atn-ds-section name="Attributes">
    <div class="details-tab__attributes">
      @for (kv of selectedRecordAttributesSg() | keyvalue; track $index) {
        <div class="details-tab__attribute">
          <span class="details-tab__attribute-key">{{
            kv.key | titlecase
          }}</span>
          <span class="details-tab__attribute-value">{{ kv.value }}</span>
        </div>
      }
    </div>
  </atn-ds-section>
</div>
